/**
 * /table · SortChips — the resurrection of the dead `sort` state.
 *
 * Backend has supported `sort` (relevance | rating | price_asc |
 * price_desc) for months, but no UI ever exposed it. This is the
 * four-chip row that sits above the results grid and re-fires the
 * live search when toggled.
 *
 * Doctrine: "Best match" is the default. We do NOT pre-select another
 * mode automatically — that would silently change what the member
 * came for. The member opts in.
 */
import React from "react";

const SORTS = [
    { value: "relevance",  label: "Best match" },
    { value: "rating",     label: "Highest rated" },
    { value: "price_asc",  label: "£ low → high" },
    { value: "price_desc", label: "£ high → low" },
];


export function SortChips({ value, onChange }) {
    return (
        <div
            data-testid="sort-chips"
            className="flex flex-wrap items-center gap-2"
            style={{ marginBottom: 14 }}
        >
            <span
                className="t-mono uppercase"
                style={{
                    fontSize: 10,
                    letterSpacing: "0.18em",
                    color: "var(--t-ink3)",
                    marginRight: 4,
                }}
            >
                sort
            </span>
            {SORTS.map((s) => {
                const active = (value || "relevance") === s.value;
                return (
                    <button
                        key={s.value}
                        type="button"
                        data-testid={`sort-${s.value}`}
                        data-active={active ? "true" : "false"}
                        onClick={() => onChange?.(s.value)}
                        style={{
                            fontSize: 12,
                            padding: "5px 11px",
                            borderRadius: 999,
                            border: `1px solid ${active ? "var(--t-ink)" : "var(--t-line2)"}`,
                            background: active ? "var(--t-ink)" : "transparent",
                            color: active ? "var(--t-paper2)" : "var(--t-ink2)",
                            cursor: "pointer",
                            fontFamily: "'Hanken Grotesk', system-ui, sans-serif",
                            transition: "all 120ms ease",
                            fontWeight: active ? 600 : 400,
                        }}
                    >
                        {s.label}
                    </button>
                );
            })}
        </div>
    );
}
